<template>
  <div>
    <v-row v-for="detail in Object.keys(details)" :key="detail">
      <v-col cols="12">
        <h2 v-text="detail" />
        <v-simple-table
          v-if="details[detail] && typeof details[detail] === 'object' && Object.keys(details[detail]).length > 0"
        >
          <template #default>
            <thead>
              <tr>
                <th class="text-left" v-text="$t('monitoring.details.key')" />
                <th class="text-left" v-text="$t('monitoring.details.value')" />
              </tr>
            </thead>
            <tbody>
              <tr v-for="key in Object.keys(details[detail])" :key="key" >
                <td v-text="key" />
                <td v-text="details[detail][key]" />
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-else v-text="details[detail]" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'Details',

  props: {
    details: [Array, Object]
  }

}
</script>
